<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="17.5 15 11.2 20"
        :height="height" :class="classes" class="fill-current">
        <path d="M27.3 34.7L17.6 25l9.7-9.7 1.4 1.4-8.3 8.3 8.3 8.3z"/>
    </svg>
</template>

<script>
export default {
    props: [ 'height', 'classes' ]
}
</script>